var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4194 23.0263L62.3227 22.4119L60.4194 23.0263C60.7457 24.0373 61.3857 24.9181 62.2464 25.5409L68.4584 30.0362C68.8105 30.291 68.9577 30.7441 68.8226 31.1572L66.4392 38.4452C66.109 39.455 66.109 40.5437 66.4392 41.5535L68.8226 48.8415C68.9577 49.2546 68.8105 49.7077 68.4584 49.9625L62.2463 54.4578C61.3857 55.0806 60.7457 55.9614 60.4194 56.9724L62.3227 57.5868L60.4194 56.9724L58.0637 64.2696C57.9302 64.6832 57.5448 64.9632 57.1102 64.9624L49.4422 64.9479C48.3798 64.9459 47.3444 65.2823 46.4861 65.9084L40.2912 70.4272C39.9401 70.6834 39.4637 70.6834 39.1126 70.4272L32.9176 65.9084C32.0593 65.2823 31.0239 64.9459 29.9615 64.9479L22.2936 64.9624C21.859 64.9632 21.4736 64.6832 21.3401 64.2696L18.9844 56.9724C18.658 55.9614 18.0181 55.0806 17.1574 54.4578L10.9454 49.9625C10.5933 49.7077 10.446 49.2546 10.5811 48.8415L12.9645 41.5535C13.2948 40.5437 13.2948 39.455 12.9645 38.4452L10.5811 31.1572C10.446 30.7441 10.5933 30.291 10.9454 30.0362L17.1574 25.5409C18.0181 24.9181 18.658 24.0373 18.9844 23.0263L21.3401 15.7291C21.4736 15.3155 21.859 15.0355 22.2936 15.0363L29.9615 15.0509C31.0239 15.0529 32.0593 14.7165 32.9176 14.0904L31.739 12.4746L32.9176 14.0904L39.1126 9.57146C39.4637 9.31533 39.9401 9.31533 40.2912 9.57146L41.4698 7.95567L40.2912 9.57146L46.4861 14.0904C47.3444 14.7165 48.3799 15.0529 49.4423 15.0509L57.1102 15.0363C57.5448 15.0355 57.9302 15.3155 58.0637 15.7291L60.4194 23.0263Z",
    fill: "#3056D3",
    stroke: "#021658",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3325 39.9993L36.6659 48.3327L53.3325 31.666",
    fill: "#3056D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3325 39.9993L36.6659 48.3327L53.3325 31.666",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d5d8238d24c4bf40a1eae12d206d3bda.svg";
export { ForwardRef as ReactComponent };